import { allowedDebugLocations } from '../config/urls';

export const isDebugEnabled = (): boolean =>
  allowedDebugLocations.indexOf(window.location.hostname) !== -1;

if (isDebugEnabled()) {
  // localStorage.debug = '*';
}
